import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, Surface, Empty } from "../components/Primitives";
import { MessageSquare, RefreshCw } from "lucide-react";

export default function SmsOutbox() {
  const [data, setData] = useState({ items: [], dev_mode: false });
  const load = async () => { const r = await api.get("/dev/sms-outbox"); setData(r.data); };
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, []);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Boîte d'envoi SMS (Dev)"
        subtitle={data.dev_mode ? "Mode développement · Aperçu local" : "Mode production"}
        actions={<button onClick={load} className="btn-ghost flex items-center gap-2"><RefreshCw size={14}/>Rafraîchir</button>}
      />
      {!data.dev_mode && (
        <Surface><div className="p-5 text-sm text-[var(--text-muted)]">Le mode dev est désactivé. Les SMS sont envoyés via le fournisseur réel.</div></Surface>
      )}
      <Surface title="Derniers SMS générés">
        {data.items.length === 0 ? <Empty message="Aucun SMS récent" /> : (
          <div className="divide-y divide-[var(--border-line)]">
            {data.items.map((s) => (
              <div key={s.id} className="p-4 flex items-start gap-4">
                <MessageSquare size={16} className="text-[var(--primary)] mt-1 shrink-0"/>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <span className="font-data text-sm">{s.phone || <span className="text-[var(--text-muted)]">(pas de numéro)</span>}</span>
                    <span className="badge-info">{s.purpose || "info"}</span>
                    <span className={s.status === "sent" ? "badge-success" : s.status === "mock" ? "badge-warn" : "badge-alert"}>{s.status}</span>
                    <span className="font-data text-xs text-[var(--text-muted)] ml-auto">{s.created_at?.slice(0,16).replace("T"," ")}</span>
                  </div>
                  <div className="text-sm text-white/90 font-data leading-relaxed">{s.message}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Surface>
    </div>
  );
}
